





























































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'

@Component
export default class FinanceiroTabelaIndicacao extends Vue {
  deleteRegraDeCalculo: boolean = false
  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get indicacoesList() { return this.getRegrasDeCalculoStore.indicacoes }

  loadRegrasDeCalculo: boolean = false
  get loadingRegrasDeCalculo() { return this.loadRegrasDeCalculo }
  set loadingRegrasDeCalculo(value: boolean) { this.loadRegrasDeCalculo = value }

  get showModalIncluir() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoIndicacao }
  set showModalIncluir(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoIndicacao', value }) }

  get showModalDelete() { return this.deleteRegraDeCalculo }
  set showModalDelete(value: boolean) { this.deleteRegraDeCalculo = value }

  get paginacaoRegrasDeCalculo() { return this.getRegrasDeCalculoStore.paginacaoRegrasDeCalculo }

  headers = [
    { text: 'Prestador', value: 'prestadorIndicadorNome', sortable: false },
    { text: 'Profissional', value: 'nomeProfissionalExecutanteIndicacaoNome', sortable: false },
    { text: 'Descricao', value: 'descricao', sortable: false },
    { text: 'Criado Por', value: 'createdByNome', sortable: false },
    { text: 'Inicio vigência', value: 'vigenciaInicio', sortable: false },
    { text: 'Fim vigência', value: 'vigenciaFim', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  loadingEditarRegraDeCalculo: string = ''
  loadingDeleteCalculo: boolean = false

  displayDate(value: any) {
    if (!value) return ' - '
    return moment(value).format('DD/MM/YYYY')
  }

  openModalDelete(id: number) {
    this.getRegrasDeCalculoStore.setDeleteId(id)
    this.showModalDelete = true
  }

  async editarRegra(item: any) {
    this.loadingEditarRegraDeCalculo = item.id
    this.getRegrasDeCalculoStore.setModeIndicacao('EDIT')
    this.getRegrasDeCalculoStore.setIndicacaoItem(item)
    this.showModalIncluir = true
    this.loadingEditarRegraDeCalculo = ''
  }

  async deleteRegra() {
    this.loadingDeleteCalculo = true
    const request = await this.getRegrasDeCalculoStore.deleteIndicacao()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeleteCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Regra de cálculo excluída com sucesso!',
      icon: 'check',
      color: '#43A047',
    })
    this.showModalDelete = false
    this.loadingDeleteCalculo = false
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getIndicacoesAll(param), 700)

  async updatePaginationRegrasDeCalculo(pagination: DataTablePagination) {
    this.loadingRegrasDeCalculo = true
    this.regrasDeCalculoDebounced(pagination)
    this.loadingRegrasDeCalculo = false
  }

  beforeDestroy() {
    this.getRegrasDeCalculoStore.clearRegrasDeCalculo()
    this.getRegrasDeCalculoStore.clearRegraDeCalculo()
    this.getRegrasDeCalculoStore.clearTabelasPreco()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoContratos()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoOperadoras()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoProcedimentosDescartar()
  }
}
